/** Human labels for flow step ids. The id stays the executor key. */
const STEP_TITLES: Record<string, string> = {
  'late_todos.shadow_preview': 'Late-todo reminders',
  'inbox.post_thread': 'Post to Inbox',
  'email.send': 'Send email',
  'email.send_batch': 'Send email batch',
}

export const INPUT_PRESENTATION: Record<string, { label: string; hint: string }> = {
  bcc: {
    label: 'BCC',
    hint: 'Hidden copy on each client email. Not the To line.',
  },
  deliver: {
    label: 'Deliver',
    hint: 'live sends the email. shadow writes a ledger and sends nothing.',
  },
  redirect_to: {
    label: 'Redirect to',
    hint: 'Sender test. Replaces the client To line.',
  },
  connection: {
    label: 'SMTP connection',
    hint: 'Named connection. This sets the From address.',
  },
  assignee_kind: {
    label: 'Assignees',
    hint: 'client includes client assignees only.',
  },
  notify_emails: {
    label: 'Inbox emails',
    hint: 'Maater Inbox audience. Does not change who the email is addressed to.',
  },
}

export const POLICY_HINTS: Record<string, string> = {
  allow_remote_writes: 'Required before a live email can send.',
  runs_per_hour: 'Cap on how often this flow can start.',
  auto_pause_after_failures: 'Schedule pauses after this many failed runs.',
  timeout_seconds: 'Max time for one run.',
}

/** Inputs edited by the Inbox picker, so the raw YAML dump should not repeat them. */
export const INBOX_PICKER_INPUTS = ['notify_emails', 'notify_email', 'audience'] as const

export function flowStepTitle(stepId: string | undefined): string | null {
  if (!stepId) return null
  return STEP_TITLES[stepId] ?? null
}

export function flowDeliverMode(steps: unknown): 'live' | 'shadow' | null {
  if (!Array.isArray(steps)) return null
  for (const step of steps) {
    if (!step || typeof step !== 'object') continue
    const inputs = (step as { inputs?: unknown }).inputs
    if (!inputs || typeof inputs !== 'object' || Array.isArray(inputs)) continue
    const deliver = (inputs as { deliver?: unknown }).deliver
    if (deliver === 'live' || deliver === 'shadow') return deliver
  }
  return null
}

export function lateTodoSendSummary(inputs: Record<string, unknown> | undefined): string | null {
  const deliver = inputs?.deliver
  const redirect = Array.isArray(inputs?.redirect_to) ? inputs.redirect_to.filter(Boolean) : []
  const bcc = Array.isArray(inputs?.bcc) ? inputs.bcc.filter(Boolean) : []
  if (deliver === 'live' && redirect.length > 0) {
    return 'Sender test. The To line is replaced, so clients are not mailed.'
  }
  if (deliver === 'live' && bcc.length > 0) {
    return 'Live client send. Each duck goes to the real client. BCC is a hidden copy. Inbox recipients below are not the To line.'
  }
  if (deliver === 'live') {
    return 'Live is set, but there is no BCC and no redirect. A run will refuse to send.'
  }
  if (deliver === 'shadow') {
    return 'Shadow. No email is sent. The run writes a ledger and an Inbox summary.'
  }
  return null
}
